import CustomerTypeHandler from "../components/customerTypeHandler";

/**
 * Tab System
 * Handles tab switching and URL hash navigation
 */
document.addEventListener("DOMContentLoaded", () => {
  const tabButtons = document.querySelectorAll(".tab-button");
  const tabContents = document.querySelectorAll(".tab-content");

  function switchTab(tabId) {
    // Remove active class from all buttons and contents
    tabButtons.forEach((button) => button.classList.remove("active"));
    tabContents.forEach((content) => content.classList.remove("active"));

    // Add active class to selected button and content
    const selectedButton = document.querySelector(`[data-tab="${tabId}"]`);
    const selectedContent = document.getElementById(tabId);

    if (selectedButton && selectedContent) {
      selectedButton.classList.add("active");
      selectedContent.classList.add("active");
    }
  }

  // Add click handlers to tab buttons
  tabButtons.forEach((button) => {
    button.addEventListener("click", () => {
      const tabId = button.getAttribute("data-tab");
      switchTab(tabId);
    });
  });

  // Check for hash in URL and switch to that tab if it exists
  const hash = window.location.hash.replace("#", "");
  if (hash && document.getElementById(hash)) {
    switchTab(hash);
  }

  // Initialize customer type handler if on addresses tab
  if (document.querySelector(".addresses-container")) {
    new CustomerTypeHandler("my-account");
  }

  // Create instance of CustomerTypeHandler
  const customerTypeHandler = new CustomerTypeHandler("my-account");

  // Address Form Handling
  const editButtons = document.querySelectorAll(".edit-address");

  // Toggle address forms
  editButtons.forEach((button) => {
    button.addEventListener("click", () => {
      const type = button.dataset.type;
      const form = document.querySelector(`.${type}-form`);
      const display = button
        .closest(".address-column")
        .querySelector(".address-display");

      if (form.style.display === "none") {
        form.style.display = "block";
        display.style.display = "none";
        button.textContent = myAccountData.buttonText.cancel;
      } else {
        form.style.display = "none";
        display.style.display = "block";
        button.textContent = myAccountData.buttonText.edit;
      }

      // Update this section to use CustomerTypeHandler's methods
      if (form) {
        form.querySelectorAll('[name$="_turkish_id_num"]').forEach((input) => {
          customerTypeHandler.setupNumberOnlyInput(input.id, 11);
        });
        form.querySelectorAll('[name$="_tax_id_num"]').forEach((input) => {
          customerTypeHandler.setupNumberOnlyInput(input.id, 10);
        });
      }
    });
  });

  /**
   * Form Validation Configuration
   * Defines validation rules for different field types
   */
  const validators = {
    email: (value) => {
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return regex.test(value) ? "" : myAccountData.errors.email;
    },
    phone: (value) => {
      const regex = /^[0-9+\-\s()]*$/;
      return regex.test(value) ? "" : myAccountData.errors.phone;
    },
    postcode: (value) => {
      return ""; // Optional field
    },
    required: (value) => {
      return value.trim() !== "" ? "" : myAccountData.errors.required;
    },
    turkish_id: (value) => {
      if (!/^\d*$/.test(value)) return myAccountData.errors.invalidTurkishId;
      if (value.length !== 11) return myAccountData.errors.invalidTurkishId;
      return "";
    },
    tax_id: (value) => {
      if (!/^\d*$/.test(value)) return myAccountData.errors.invalidTaxId;
      if (value.length !== 10) return myAccountData.errors.invalidTaxId;
      return "";
    },
  };

  /**
   * Form Validation Functions
   * Helper functions to handle field validation and error display
   */
  function validateField(field) {
    const value = field.value;
    const isRequired = field.hasAttribute("required");
    let error = "";

    // Required field check
    if (isRequired) {
      error = validators.required(value);
      if (error) return error;
    }

    // Specific field validations
    if (value.trim()) {
      switch (field.name.replace(/^(billing|shipping)_/, "")) {
        case "email":
          error = validators.email(value);
          break;
        case "phone":
          error = validators.phone(value);
          break;
        case "postcode":
          error = validators.postcode(value);
          break;
        case "turkish_id_num":
          error = validators.turkish_id(value);
          break;
        case "tax_id_num":
          error = validators.tax_id(value);
          break;
      }
    }

    return error;
  }

  function showFieldError(field, message) {
    const parent = field.parentNode;
    // Remove existing error
    const existingError = parent.querySelector(".field-error");
    if (existingError) existingError.remove();

    // Add error class and message
    field.classList.add("has-error");
    const errorSpan = document.createElement("span");
    errorSpan.className = "field-error";
    errorSpan.textContent = message;
    parent.appendChild(errorSpan);
  }

  function clearFieldError(field) {
    const parent = field.parentNode;
    const errorSpan = parent.querySelector(".field-error");
    if (errorSpan) errorSpan.remove();
    field.classList.remove("has-error");
  }

  /**
   * Address Form Handling
   * Manages form visibility, validation, and submission
   */
  const addressForms = document.querySelectorAll(".address-form");
  addressForms.forEach((form) => {
    // Real-time validation on input
    form.querySelectorAll("input, select").forEach((field) => {
      field.addEventListener("input", () => {
        const error = validateField(field);
        if (error) {
          showFieldError(field, error);
        } else {
          clearFieldError(field);
        }
      });

      // Validate on blur
      field.addEventListener("blur", () => {
        const error = validateField(field);
        if (error) {
          showFieldError(field, error);
        }
      });
    });

    form.addEventListener("submit", (e) => {
      e.preventDefault();

      // Validate all fields
      let hasErrors = false;
      form.querySelectorAll("input, select").forEach((field) => {
        const error = validateField(field);
        if (error) {
          showFieldError(field, error);
          hasErrors = true;
        } else {
          clearFieldError(field);
        }
      });

      if (hasErrors) return;

      const formData = new FormData(form);
      const type = form.classList.contains("billing-form")
        ? "billing"
        : "shipping";
      const submitButton = form.querySelector(".save-address-btn");

      formData.append("action", "save_address");
      formData.append("address_type", type);
      formData.append("nonce", myAccountData.nonce);

      // Disable form while submitting
      submitButton.disabled = true;

      fetch(myAccountData.ajaxUrl, {
        method: "POST",
        body: formData,
        headers: {
          "X-Requested-With": "XMLHttpRequest",
        },
      })
        .then(async (response) => {
          const contentType = response.headers.get("content-type");
          const responseData = await response.text();

          let parsedData;
          try {
            parsedData = JSON.parse(responseData);
          } catch (e) {
            console.error("Response parsing error:", e);
            console.log("Raw response:", responseData);
            throw new Error("Invalid JSON response from server");
          }

          if (!response.ok) {
            throw new Error(
              parsedData?.data?.message ||
                parsedData?.message ||
                `Server error (${response.status})`
            );
          }

          return parsedData;
        })
        .then((data) => {
          if (data.success) {
            location.reload();
          } else {
            if (data.data?.field_errors) {
              Object.entries(data.data.field_errors).forEach(
                ([field, message]) => {
                  const inputField = form.querySelector(`[name="${field}"]`);
                  if (inputField) {
                    showFieldError(inputField, message);
                  }
                }
              );
            } else {
              console.error("Server error details:", data);
              alert(data.data?.message || myAccountData.messages.unknownError);
            }
          }
        })
        .catch((error) => {
          console.error("Form submission error:", error);
          alert(error.message || myAccountData.messages.unknownError);
        })
        .finally(() => {
          submitButton.disabled = false;
        });
    });
  });

  /**
   * Copy Billing Address Feature
   * Allows copying billing address to shipping address
   */
  const copyCheckbox = document.getElementById("copy-billing-address");
  const confirmButton = document.getElementById("confirm-copy-address");

  if (copyCheckbox && confirmButton) {
    copyCheckbox.addEventListener("change", function () {
      confirmButton.style.display = this.checked ? "block" : "none";
    });

    confirmButton.addEventListener("click", function () {
      const billingForm = document.querySelector(".billing-form");
      if (!billingForm) return;

      const formData = new FormData();
      formData.append("action", "save_address");
      formData.append("address_type", "shipping");
      formData.append("nonce", myAccountData.nonce);
      formData.append("copy_from_billing", "1"); // Add flag to handle copying on server side

      confirmButton.disabled = true;

      fetch(myAccountData.ajaxUrl, {
        method: "POST",
        body: formData,
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.success) {
            location.reload();
          } else {
            alert(myAccountData.messages.unknownError);
            confirmButton.disabled = false;
          }
        })
        .catch(() => {
          alert(myAccountData.messages.unknownError);
          confirmButton.disabled = false;
        });
    });
  }

  /**
   * Account Details Form
   * Handles account information updates
   */
  const accountForm = document.querySelector(".account-details-form");
  if (accountForm) {
    accountForm.addEventListener("submit", (e) => {
      e.preventDefault();
      const formData = new FormData(accountForm);
      formData.append("action", "save_account_details");
      formData.append("nonce", myAccountData.nonce);

      fetch(myAccountData.ajaxUrl, {
        method: "POST",
        body: formData,
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.success) {
            location.reload();
          } else {
            // Show error message
            const errorDiv = document.createElement("div");
            errorDiv.className = "error-message";
            errorDiv.textContent = data.data.message;
            accountForm.insertBefore(errorDiv, accountForm.firstChild);
          }
        })
        .catch((error) => console.error("Error:", error));
    });
  }

  /**
   * Account Details Form Validation
   */
  if (accountForm) {
    const showFieldError = (field, message) => {
      const parent = field.parentNode;
      const existingError = parent.querySelector(".field-error");
      if (existingError) existingError.remove();

      field.classList.add("has-error");
      const errorSpan = document.createElement("span");
      errorSpan.className = "field-error";
      errorSpan.textContent = message;
      parent.appendChild(errorSpan);
    };

    const clearFieldError = (field) => {
      const parent = field.parentNode;
      const errorSpan = parent.querySelector(".field-error");
      if (errorSpan) errorSpan.remove();
      field.classList.remove("has-error");
    };

    const validatePassword = (password) => {
      if (password.length < 8) {
        return myAccountData.accountErrors.passwordLength;
      }

      if (!/[A-Z]/.test(password)) {
        return myAccountData.accountErrors.passwordUppercase;
      }

      if (!/[a-z]/.test(password)) {
        return myAccountData.accountErrors.passwordLowercase;
      }

      if (!/[0-9]/.test(password)) {
        return myAccountData.accountErrors.passwordNumber;
      }

      return null;
    };

    const validateField = (field) => {
      const value = field.value.trim();
      let error = "";

      switch (field.id) {
        case "account_first_name":
        case "account_last_name":
          // Remove validation for name fields
          break;
        case "account_email":
          if (!value) {
            error = myAccountData.accountErrors.emailRequired;
          } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
            error = myAccountData.accountErrors.emailInvalid;
          }
          break;
        case "password_new":
          if (value) {
            error = validatePassword(value);
          }
          break;
        case "password_confirm":
          const newPassword = document.getElementById("password_new").value;
          if (newPassword && value !== newPassword) {
            error = myAccountData.accountErrors.passwordMatch;
          }
          break;
      }

      if (error) {
        showFieldError(field, error);
        return false;
      }

      clearFieldError(field);
      return true;
    };

    // Real-time validation
    accountForm.querySelectorAll("input").forEach((input) => {
      input.addEventListener("input", () => validateField(input));
      input.addEventListener("blur", () => validateField(input));
    });

    // Form submission
    accountForm.addEventListener("submit", async (e) => {
      e.preventDefault();
      let hasErrors = false;

      // Validate all fields
      accountForm.querySelectorAll("input").forEach((field) => {
        if (!validateField(field)) hasErrors = true;
      });

      if (hasErrors) return;

      const formData = new FormData(accountForm);
      formData.append("action", "save_account_details");
      formData.append("nonce", myAccountData.nonce);

      try {
        const response = await fetch(myAccountData.ajaxUrl, {
          method: "POST",
          body: formData,
        });

        const data = await response.json();

        if (data.success) {
          location.reload();
        } else if (data.data.field_errors) {
          Object.entries(data.data.field_errors).forEach(([field, message]) => {
            const input = accountForm.querySelector(`#${field}`);
            if (input) showFieldError(input, message);
          });
        } else {
          alert(data.data.message || myAccountData.messages.unknownError);
        }
      } catch (error) {
        console.error("Error:", error);
        alert(myAccountData.messages.unknownError);
      }
    });
  }
});
